// Ruoli di piattaforma (colonna "user".role). Il sysadmin ha i poteri
// dell'admin ma per i clienti non esiste: non compare tra i membri delle
// aziende, le estensioni che abbina restano nascoste e le sue azioni
// risultano del titolare dell'azienda.
export type PlatformRole = "user" | "admin" | "sysadmin";

export const SYSADMIN_ROLE = "sysadmin";

export function isPlatformAdminRole(role: string | null | undefined): boolean {
  return role === "admin" || role === SYSADMIN_ROLE;
}

export function isSysadminRole(role: string | null | undefined): boolean {
  return role === SYSADMIN_ROLE;
}
